import React, { useMemo } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Main from "../Main";
import {
  AppBreadcrumbs,
} from "../../components/listing";
import { formatAmount } from "../../utils/formatAmount";
import {
  decodeFinkedaReturn,
  finkedaResultBucket,
} from "../../utils/finkedaReturn";

const COPY = {
  SUCCESS: {
    title: "Payment successful",
    body: "confirmed this transaction as SUCCESS. Wallet credit is applied from the webhook, not this page.",
    className: "text-emerald-700",
  },
  FAILED: {
    title: "Payment failed",
    body: "reported this transaction as failed. If money was deducted, wait for the report to update before retrying.",
    className: "text-rose-700",
  },
  PENDING: {
    title: "Payment pending",
    body: "has not finished this transaction yet. Status will update when the webhook arrives.",
    className: "text-amber-700",
  },
  OTHER: {
    title: "Payment update",
    body: "returned a status that is not SUCCESS, FAILED, or PENDING. Showing the value as received.",
    className: "text-slate-700",
  },
};

const PaymentCallback = () => {
  const [params] = useSearchParams();
  const decoded = useMemo(
    () => decodeFinkedaReturn(params.get("status")),
    [params]
  );
  const bucket = finkedaResultBucket(decoded?.status, decoded?.bucket);
  const copy = COPY[bucket] || COPY.OTHER;
  const statusLabel = String(decoded?.status || "UNKNOWN").toUpperCase();

  return (
    <Main showRightPanel={false}>
      <div className="mt-4 max-w-xl">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Payment result" },
          ]}
        />
        <div className="ds-card p-5 mt-3">
          <p className={`text-[11px] font-semibold uppercase m-0 ${copy.className}`}>
            {statusLabel}
          </p>
          <h1 className="text-lg font-semibold mt-2 mb-2">{copy.title}</h1>
          <p className="text-[13px] text-[var(--text-muted)] m-0 mb-4">
            {decoded?.message && decoded.message !== statusLabel
              ? decoded.message
              : copy.body}
          </p>
          <div className="grid grid-cols-2 gap-2 text-[13px]">
            <p className="m-0">
              Amount:{" "}
              <strong>
                {decoded?.amount != null ? `₹${formatAmount(decoded.amount)}` : "—"}
              </strong>
            </p>
            <p className="m-0">
              Charge:{" "}
              <strong>
                {decoded?.charge != null ? `₹${formatAmount(decoded.charge)}` : "—"}
              </strong>
            </p>
            <p className="m-0 col-span-2">
              URN: <strong>{decoded?.urn || "—"}</strong>
            </p>
            <p className="m-0 col-span-2">
              Order ID: <strong>{decoded?.orderId || "—"}</strong>
            </p>
            <p className="m-0 col-span-2">
              Transaction ID: <strong>{decoded?.txnId || "—"}</strong>
            </p>
          </div>
          <div className="flex flex-wrap gap-2 mt-4">
            <Link to="/pg-payout/history" className="ds-btn ds-btn-primary">
              View reports
            </Link>
            <Link to="/pg-payout" className="ds-btn ds-btn-secondary">
              New payout
            </Link>
          </div>
        </div>
      </div>
    </Main>
  );
};

export default PaymentCallback;
